import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'hooks/useAuth';
import { useClient } from 'hooks/useClient';

/** One UTC day, `YYYY-MM-DD`. The server zero-fills every day of the month so far. */
export type UsageTimeseriesPoint = { date: string; units: number };

export type UsageTimeseries = { series: UsageTimeseriesPoint[] };

/**
 * Month-to-date daily website sessions, for UsageChart. `companyId`
 * drills into one client's series (agency view, via ClientBillingTable's row
 * selection); null is the caller's own payer-scoped total.
 */
export const useUsageTimeseries = (companyId: number | null) => {
  const apiClient = useClient();
  const { user } = useAuth();

  const { data, isLoading, isError, refetch } = useQuery<UsageTimeseries>({
    queryKey: ['BILLING_USAGE_TIMESERIES', companyId],
    enabled: !!user,
    queryFn: () => apiClient.get(`/billing/usage/timeseries${companyId ? `?companyId=${companyId}` : ''}`),
  });

  return { timeseries: data, isLoading, isError, refetch };
};
